// index.jsx
import React from 'react';
import ReactDOM from "react-dom/client";
import { Connect } from "@stacks/connect-react";

import { authOptions } from './services/auth';
import reportWebVitals from "./reportWebVitals";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Connect authOptions={authOptions}>
    <App />
  </Connect>
);

reportWebVitals();